export const NULL_FILE_URL = 'NULL_FILE_URL'
